export const OMBUDSMAN_WEB_PAGE_URL = 'https://www.bancointer.com.br/ouvidoria'
export const ATENDIMENTO_LIBRAS_URL = 'https://inter.co/atendimento-em-libras/'
export const PF_BASE_DEEP_LINK = 'bancointer://'
export const PJ_BASE_DEEP_LINK = 'interempresas://'
export const INTER_CHAT_DEEP_LINK_PATH = 'interchat'

export const OMBUDSMAN_DEEP_LINK_MESSAGE = 'Falar com especialista da ouvidoria'
